// Shared date formatting. All app dates render in US Central time.
//
// IMPORTANT: use `formatDateOnly` for DATE-ONLY fields (e.g. "2027-03-15" due dates).
// It reads the calendar date directly and never applies a timezone shift. Using
// `new Date("2027-03-15").toLocaleDateString(...)` parses as UTC midnight and rolls the
// date back a day in Central time — that class of bug is prevented by the eslint rule
// `no-restricted-syntax` (see craco.config.js) which forbids `new Date(x).toLocaleDateString`.
//
// Use `formatDate` / `formatDateTime` only for full ISO timestamps (with a time component).
export const CENTRAL_TZ = "America/Chicago";

// Date-only fields "YYYY-MM-DD" -> "MM/DD/YYYY" with NO timezone conversion.
export const formatDateOnly = (value) => {
  if (!value) return "—";
  const m = /^(\d{4})-(\d{2})-(\d{2})/.exec(String(value));
  return m ? `${m[2]}/${m[3]}/${m[1]}` : formatDate(value);
};

// Full ISO timestamps -> Central calendar date.
export const formatDate = (value, opts = {}) => {
  if (!value) return "—";
  // eslint-disable-next-line no-restricted-syntax -- central util; value is a full timestamp
  return new Date(value).toLocaleDateString("en-US", { timeZone: CENTRAL_TZ, ...opts });
};

// Full ISO timestamps -> Central date + time.
export const formatDateTime = (value, opts = {}) => {
  if (!value) return "—";
  return new Date(value).toLocaleString("en-US", { timeZone: CENTRAL_TZ, ...opts });
};

// Value for <input type="date"> (YYYY-MM-DD) in Central time. Date-only strings pass through unshifted.
export const toDateInput = (value) => {
  if (!value) return todayInput();
  const m = /^(\d{4}-\d{2}-\d{2})/.exec(String(value));
  // eslint-disable-next-line no-restricted-syntax -- central util; timestamp fallback only
  return m ? m[1] : new Date(value).toLocaleDateString("en-CA", { timeZone: CENTRAL_TZ });
};

export const todayInput = () => new Date().toLocaleDateString("en-CA", { timeZone: CENTRAL_TZ });
